import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { GenericResponse } from "src/app/entities/various";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})

export class OptimaService {

  private wsUrl = environment.url;

  constructor(private http: HttpClient, private router: Router) { }

  async richiediInformazioni(userId: number, data: any): Promise<GenericResponse> {
    return await this.http.post(this.wsUrl + "/web/v1/optima/" + userId + "/info", { data })
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }
}